module.exports = __webpack_public_path__ + "media/images/roku/tv-8398cc925d46d87a952153990949cf63.png";